import React, { useEffect } from 'react'
import { useSearchParams } from 'react-router';

function AppSsoLogin() {
    const [searchParams] = useSearchParams();
 
  useEffect(() => {
    const token = searchParams.get("SSOId");
 
    if (token) {
      // Redirect to the app
      window.location.href = `myapp://login?token=${token}`;
 
      // Fallback to Play Store after delay

    //   setTimeout(() => {
    //     window.location.href = "https://play.google.com/store/apps/details?id=com.yourapp"; // Replace with actual package name
    //   }, 2000);
    
    }
  }, []);
 
  return (
<div style={{ padding: 24, textAlign: "center" }}>
<h2>Redirecting to the app...</h2>
<p>If nothing happens, make sure the app is installed.</p>
</div>
  );
}

export default AppSsoLogin
